import { useEffect, useState } from "react";
import ExportApi from "../../api/ExportApi";
import SharedTable from "../../shared/sharedTable";
import {
    Button
} from "react-bootstrap";
import { formatToLocalDate } from '../../helper/utils';
import { toast } from "react-toastify";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const AffiliateOrders = () => {
    const [affiliateOrders, setAffiliateOrders] = useState([]);
    const [pagination, setPagination] = useState({});
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(false);

    const columns = [
        {
            name: "Date",
            key: "createdAt",
            render: (row) => {
                return (
                    <div style={{ minWidth: "100px" }}> {formatToLocalDate(row?.createdAt)}</div>
                )
            }
        },
        {
            name: "OrderID",
            render: (row) => {
                return (
                    <div style={{ minWidth: "100px" }}> {row?.orderId}</div>
                )
            }
        },
        {
            name: "Bid Subtotal",
            render: (row) => {
                return (
                    <div style={{ minWidth: "100px" }}> {row?.bidId?.subTotal}</div>
                )
            }
        },
        {
            name: "Ask Subtotal",
            render: (row) => {
                return (
                    <div style={{ minWidth: "100px" }}> {row?.askId?.subTotal ?? row?.directSellId?.subTotal}</div>
                )
            }
        },
        {
            name: "Buyer",
            render: (row) => {
                return (
                    <div className="d-flex flex-column">
                        <span>{row?.buyerId?.email || "N/A"}</span>
                    </div>
                )
            }
        },
        {
            name: "Seller",
            render: (row) => {
                return (
                    <div className="d-flex flex-column">
                        {/* <span>name - {`${row?.sellerId?.firstname} ${row?.sellerId?.lastname}`}</span> */}
                        <span>{row?.sellerId?.email || "N/A"}</span>
                    </div>
                )
            }
        },
        {
            name: "Affiliate for seller",
            render: (row) => {
                return (
                    <div className="d-flex flex-column">
                        {/* <span>Code - {row?.affiliate_attribution?.affiliate_id_seller?.code || "N/A"}</span> */}
                        <span>name - {row?.affiliate_attribution?.affiliate_id_seller?.name || "N/A"}</span>
                        {/* {
                            row?.affiliate_attribution?.affiliate_id_seller && row?.affiliate_attribution?.affiliate_assigned_at_seller && (
                                <span>Assigned_at - {formatToLocalDate(row?.affiliate_attribution?.affiliate_assigned_at_seller)}</span>
                            )
                        } */}
                    </div>
                )
            }
        },
        {
            name: "Affiliate for buyer",
            render: (row) => {
                return (
                    <div className="d-flex flex-column">
                        {/* <span>Code - {row?.affiliate_attribution?.affiliate_id_buyer?.code || "N/A"}</span> */}
                        <span>name - {row?.affiliate_attribution?.affiliate_id_buyer?.name || "N/A"}</span>
                        {/* {
                            row?.affiliate_attribution?.affiliate_id_buyer && row?.affiliate_attribution?.affiliate_assigned_at_buyer && (
                                <span>Assigned_at - {formatToLocalDate(row?.affiliate_attribution?.affiliate_assigned_at_buyer)}</span>
                            )
                        } */}
                    </div>
                )
            }
        },
        {
            name: "Order status",
            render: (row) => {
                return (
                    <div className="d-flex flex-column">
                        <span>{row?.deliveryStatusId?.deliveryStatus?.status || "N/A"}</span>
                    </div>
                )
            }
        },
        {
            name: "Payment transfer to seller",
            render: (row) => {
                return (
                    <div className="d-flex flex-column">
                        <span>{row?.payment_transfer_to_seller || "N/A"}</span>
                    </div>
                )
            }
        },

    ]

    const downloadCSV = async () => {
        try {
            const resp = await ExportApi.downloadCSVForAffiliateOrders({
                responseType: "blob"
            });

            const blob = new Blob([resp.data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "affiliate-orders.csv");
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (err) {
            console.error(err);
            toast.error("Error downloading CSV");
        }
    };

    const handlePageClick = (event, value) => {
        setPage(value);
    };

    const getAffiliateOrders = async (pageParam) => {
        setLoader(true);
        try {
            const resp = await ExportApi.getAffiliateOrders({ pageParam });
            if (resp?.data.success) {
                setLoader(false);
                setPagination(resp?.data?.data?.pagination)
                setAffiliateOrders(resp?.data?.data?.records || [])
            }
            else {
                setLoader(false);
                setAffiliateOrders([])
            }
        } catch (err) {
            setLoader(false);
            setAffiliateOrders([])
            console.error(err);
            toast.error("Error downloading CSV");
        }
    }

    useEffect(() => {
        getAffiliateOrders(page);
    }, [page])

    return (
        <div className="py-4">
            <div style={{ cursor: "pointer" }} className="d-flex justify-content-end align-items-end pb-2">
                <Button onClick={downloadCSV} style={{ backgroundColor: "black", color: "#fff" }} variant="primary" type="submit" className="">
                    Download CSV
                </Button>
            </div>

            <SharedTable loader={loader} columns={columns} data={affiliateOrders || []} />

            {
                pagination?.totalPages > 1 && (
                    <Stack spacing={2}>
                        <Pagination
                            className="order_pagination"
                            count={pagination?.totalPages || 0}
                            color="primary"
                            hidePrevButton
                            hideNextButton
                            page={pagination?.page}
                            onChange={handlePageClick}
                        />
                    </Stack>
                )
            }

        </div>
    )
}

export default AffiliateOrders;